<template>
  <Base :base-id="'size-report'">
    <template #header>
      <a href="#" class="r-lightbox__close" @click="closeModal" />
    </template>
    <template #body>
      <div v-html="modalData.SizeReport" />
    </template>
  </Base>
</template>

<script setup>
import { nextTick, onMounted } from 'vue';
import $ from 'jquery';
import { storeToRefs } from 'pinia';

import useModalStore from '@global/stores/useModalStore';

import Base from '@global/components/common/modal/Base.vue';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);

onMounted(() => {
  nextTick(() => {
    $('#size-report .size-guide__content').hide();
    $('#size-report .size-guide').find('.size-guide__section').eq(0).addClass('opened');
    $('#size-report .size-guide').find('.size-guide__content').eq(0).show();
    $('#size-report .size-guide__section>h2').click(function () {
      $(this)
        .parents('.size-guide__section')
        .siblings()
        .removeClass('opened')
        .find('.size-guide__content')
        .slideUp();
      $(this)
        .parents('.size-guide__section')
        .toggleClass('opened')
        .find('.size-guide__content')
        .slideToggle();
    });
  });
});
</script>
